import React, {Component} from 'react'
import {Button, Card, Col, Form, Icon, Input, Row, Switch, Cascader} from 'antd'
import BarChrt from './Bar'

class Bar extends Component {
  render() {
    return (
      <Card title="Cupones por categoría">
        <BarChrt />
      </Card>
    )
  }
}

export default Bar



// WEBPACK FOOTER //
// ./src/routes/main/Reports/bar/index.js